import { render } from "./ApartmentSwitcher.vue?vue&type=template&id=a564318a"
import script from "./ApartmentSwitcher.vue?vue&type=script&lang=js"
export * from "./ApartmentSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__